// extracted by mini-css-extract-plugin
export default {"background":"Attribute_background__bIPwx","el7Tiene":"Attribute_el7Tiene__bN6WF","attributes":"Attribute_attributes__aY5QM","linkToIpfs":"Attribute_linkToIpfs__xLsRm"};